import $ from "jquery";
import Swiper from 'swiper/bundle';

$(function() {
    $(".bl-logocarousel").each(function() {
        const $bl = $(this);
        initBlock($bl);
    });
});

function initBlock($bl) {
    let slidesPerView = 4;
    if($bl.closest(".la-2col").length > 0) {
      //Block is inside a 2 column layout
      slidesPerView = 2;
    }

    const swiper = new Swiper($bl.find('.swiper').get(0), {
        //loop: true,
        //rewind: true,
        //autoHeight: true,
        slidesPerView: slidesPerView,
        centerInsufficientSlides: true,
        spaceBetween: 20,
        
        pagination: {
          el: $bl.find('.swiper-pagination').get(0),
          clickable: true
        },

        /*
        navigation: {
          nextEl: $bl.find('.button-next').get(0),
          prevEl: $bl.find('.button-prev').get(0),
        },
        */
  
        /*
        speed: 1500,
        autoplay: {
          delay: 4000
        }
        */
  
    });
}

